<template>
  <div class="filter-section flex-clz">
    <div class="input-box-container">
      <el-row gutter="10">
        <el-col :span="8" v-for="(item, index) in inputConfigs" :key="index" v-show="isExpanded || index < 2">
          <el-form-item :label="item.label">
            <el-input v-model="item.value" :placeholder="inputPlaceholder"></el-input>
          </el-form-item>
          <!-- 鍦ㄧ粍浠跺唴閮ㄦ柊澧炰竴涓绠楀睘鎬ф垨鑰呮暟鎹睘鎬ф潵瀛樻斁鍗犱綅绗﹀唴瀹?-->
          <span v-if="!inputPlaceholder">{{ setPlaceholder(item.label) }}</span>
        </el-col>
      </el-row>
    </div>
    <el-button type="text" @click="toggleInputBoxes" :icon="isExpanded? 'ArrowUp' : 'ArrowDown'">
      {{ isExpanded? '收起' : '展开' }}
    </el-button>
    <div class="flex button-clz"><el-button type="primary" :icon="Search" @click="initUserList">搜索</el-button></div>
  </div>

  <div class=" flex-clz">
    <div class="flex button-clz"><el-button type="primary" :icon="Download" @click="initUserList">导出</el-button></div>
    <el-table :data="tableData" stripe border style="width: 100%">
      <el-table-column prop="wageBatch" label="工资表批次" align="center" />
      <el-table-column prop="createDate" label="创建日期" align="center" />
      <el-table-column prop="totalWage" label="应发/到账工资总额(元)" align="center" />
      <el-table-column prop="totalPeople" label="应发/到账总人数" align="center" />
      <el-table-column prop="wageStatus" label="工资表状态" align="center" />
      <el-table-column prop="isUploadAttendance" label="是否上传考勤表" align="center" />
      <el-table-column prop="isUploadSignature" label="是否上传工人签字确认表" align="center" />
      <el-table-column prop="isUploadBankReversal" label="是否上传银行回执" align="center" />
      <el-table-column prop="appConfirmedPeople" label="app已确认人数" align="center" />
      <el-table-column prop="action" label="操作"  fixed="right" align="center">
        <template #default="scope">
          <a  >查看详情</a>
        </template>
      </el-table-column>
    </el-table>
    </div>
  <div>
    <Pagination ref="childComponentRef" @data-sent="handleData" :apiUrl="myApiUrl" :searchParams="searchParams"></Pagination>
  </div>
</template>

<script setup>
import {Search, Download, ArrowUp, ArrowDown} from "@element-plus/icons-vue";
import {ref, reactive, onMounted} from 'vue';
import Pagination from "@/views/common/Pagination.vue";

// 响应式数据
const isExpanded = ref(false); // 用于控制是否展开的状态，初始设为展开
const inputConfigs = reactive([
  { label: "发薪年月", value: "" },
  { label: "工资表状态", value: "" },
  { label: "是否上传考勤表", value: "" },
  { label: "是否上传工人签字确认表", value: "" },
  { label: "是否上传银行回执", value: "" },
  { label: "订单号", value: "" }
]);
const tableData = reactive([

]);
const inputPlaceholder = ref("");

// 方法定义
const toggleInputBoxes = () => {
  isExpanded.value =!isExpanded.value;
};

const setPlaceholder = (label) => {
  inputPlaceholder.value = `请输入${label}`;
  return inputPlaceholder.value;
};

const initUserList = () => {
  console.log('这里需要根据具体功能完善initUserList方法逻辑');
};

const viewDetails = (project) => {
  console.log('这里需要完善查看详情的具体逻辑，比如跳转到详情页等', project);
};

</script>

<style scoped>

</style>